import { GenericErrorPage } from "dsl/atoms/ErrorPages";
import RedirectRoot from "dsl/atoms/RedirectRoot";
import lazy from "dsl/atoms/retry";
import B2CHeader from "dsl/ecosystems/B2CDashboard/B2CHeader";
import { DEFAULT_ONBOARDING_PAGE } from "dsl/ecosystems/B2COnboarding";
import { Navigate, Route, Routes } from "react-router-dom";

const B2CDashboardPage = lazy(() => import("dsl/ecosystems/B2CDashboard"));
const ProviderDetailsPage = lazy(
  () => import("dsl/ecosystems/ProviderDetailsPage"),
);
const SPNDetailsPage = lazy(
  () => import("dsl/ecosystems/ProviderDetailsPage/SPNDetailsPage"),
);
const B2COnboarding = lazy(() => import("dsl/ecosystems/B2COnboarding"));

const defaultRedirectPath = `/b2c/onboarding/${DEFAULT_ONBOARDING_PAGE}`;

export default function B2CRoutes() {
  return (
    <Routes>
      <Route element={<GenericErrorPage />} path="error" />
      <Route element={<Navigate replace to={defaultRedirectPath} />} index />
      <Route element={<B2CHeader />} path="/b2c/*">
        <Route element={<B2CDashboardPage />} path="dashboard" />
        <Route path="provider">
          <Route element={<ProviderDetailsPage />} index />
          <Route element={<ProviderDetailsPage />} path=":providerId" />
        </Route>
        <Route path="spn">
          <Route element={<SPNDetailsPage />} index />
          <Route element={<SPNDetailsPage />} path=":zipcode" />
        </Route>
        <Route path="onboarding">
          <Route element={<B2COnboarding />} path=":page" />
          <Route
            element={<Navigate replace to={defaultRedirectPath} />}
            path="*"
          />
        </Route>
        <Route element={<RedirectRoot to={defaultRedirectPath} />} path="*" />
      </Route>
    </Routes>
  );
}
